<template>
  <IconButton
    icon="edit"
    :title="$t('actions.edit')"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import IconButton from "./components/BaseButton";

export default {
  components: {
    IconButton
  },
};
</script>

<style lang="scss" scoped>
</style>